import { COMPANY } from "../actions/types";

const initialState = {
  getCompanies: {
    companies: {},
    isFetching: false,
    errorMessage: null,
  },
  deleteCompany: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  assignEmployee: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  getCompanyEmployees: {
    companyEmployees: {},
    errorMessage: null,
    isFetching: false,
  },
  getCompanyEmployee: {
    companyEmployee: {},
    errorMessage: null,
    isFetching: false,
  },
  updateCompanyEmployee: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  deleteCompanyEmployee: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  getSchedule: {
    schedule: [],
    errorMessage: null,
    isFetching: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // #region COMPANY.GET_COMPANIES

    case COMPANY.COMPANY_GET_COMPANIES_REQUEST:
      return {
        ...state,
        getCompanies: {
          companies: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case COMPANY.COMPANY_GET_COMPANIES_SUCCESS:
      return {
        ...state,
        getCompanies: {
          companies: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case COMPANY.COMPANY_GET_COMPANIES_FAIL:
      return {
        ...state,
        getCompanies: {
          companies: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region COMPANY_DELETE

    case COMPANY.COMPANY_DELETE_REQUEST:
      return {
        ...state,
        deleteCompany: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case COMPANY.COMPANY_DELETE_SUCCESS:
      return {
        ...state,
        deleteCompany: {
          successMessage: "Bedrijf verwijderen is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case COMPANY.COMPANY_DELETE_FAIL:
      return {
        ...state,
        deleteCompany: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region COMPANY.ASSIGN_EMPLOYEE

    case COMPANY.COMPANY_ASSIGN_EMPLOYEE_REQUEST:
      return {
        ...state,
        assignEmployee: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case COMPANY.COMPANY_ASSIGN_EMPLOYEE_SUCCESS:
      return {
        ...state,
        assignEmployee: {
          successMessage: "Medewerker aan bedrijf toevoegen is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case COMPANY.COMPANY_ASSIGN_EMPLOYEE_FAIL:
      return {
        ...state,
        assignEmployee: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region COMPANY.GET_COMPANY_EMPLOYEES

    case COMPANY.COMPANY_GET_COMPANY_EMPLOYEES_REQUEST:
      return {
        ...state,
        getCompanyEmployees: {
          companyEmployees: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case COMPANY.COMPANY_GET_COMPANY_EMPLOYEES_SUCCESS:
      return {
        ...state,
        getCompanyEmployees: {
          companyEmployees: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case COMPANY.COMPANY_GET_COMPANY_EMPLOYEES_FAIL:
      return {
        ...state,
        getCompanyEmployees: {
          companyEmployees: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region COMPANY.GET_COMPANY_EMPLOYEE

    case COMPANY.COMPANY_GET_COMPANY_EMPLOYEE_REQUEST:
      return {
        ...state,
        getCompanyEmployee: {
          companyEmployee: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case COMPANY.COMPANY_GET_COMPANY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        getCompanyEmployee: {
          companyEmployee: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case COMPANY.COMPANY_GET_COMPANY_EMPLOYEE_FAIL:
      return {
        ...state,
        getCompanyEmployee: {
          companyEmployee: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region COMPANY_UPDATE

    case COMPANY.COMPANY_UPDATE_COMPANY_EMPLOYEE_REQUEST:
      return {
        ...state,
        updateCompanyEmployee: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case COMPANY.COMPANY_UPDATE_COMPANY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        updateCompanyEmployee: {
          successMessage: "Bijwerken is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case COMPANY.COMPANY_UPDATE_COMPANY_EMPLOYEE_FAIL:
      return {
        ...state,
        updateCompanyEmployee: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region COMPANY_DELETE_COMPANY_EMPLOYEE

    case COMPANY.COMPANY_DELETE_COMPANY_EMPLOYEE_REQUEST:
      return {
        ...state,
        deleteCompanyEmployee: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case COMPANY.COMPANY_DELETE_COMPANY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        deleteCompanyEmployee: {
          successMessage: "Medewerker van bedrijf verwijderen is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case COMPANY.COMPANY_DELETE_COMPANY_EMPLOYEE_FAIL:
      return {
        ...state,
        deleteCompanyEmployee: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region COMPANY.GET_SCHEDULE

    case COMPANY.COMPANY_GET_SCHEDULE_REQUEST:
      return {
        ...state,
        getSchedule: {
          schedule: [],
          errorMessage: null,
          isFetching: true,
        },
      };

    case COMPANY.COMPANY_GET_SCHEDULE_SUCCESS:
      return {
        ...state,
        getSchedule: {
          schedule: action.payload,
          errorMessage: null,
          isFetching: false,
        },
      };

    case COMPANY.COMPANY_GET_SCHEDULE_FAIL:
      return {
        ...state,
        getSchedule: {
          schedule: [],
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/companyReducer.js